// NPM Imports
import React, { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import { OnBoardPopUp } from "../../../commonComponents";

export default function NavBarItemOnboard(props) {
  // * LOCAL STATE DECLARATION SYNTAX
  const [showPopUp, togglePopUp] = useState(false);

  const { item } = props;
  return (
    <Fragment>
      <div
        onClick={() => togglePopUp(true)}
        onKeyDown={() => togglePopUp(true)}
        data-test="navbar-item navbar-item-tnb"
        className="navbar-item"
        id={`top-navbar-item-${item.name}`}
        role="button"
        tabIndex={0}>
        <i className="navbar-icon">
          <img src={item.ico} alt="icon" width="22px" height="22px" />
          <span className="navbar-item-onboard-label">
            <FontAwesomeIcon icon={["fas", "play-circle"]} />
          </span>
        </i>
        <span className="navbar-title">{item.tooltip}</span>
      </div>

      {/* UPGRADE POPUP SECTION */}
      {showPopUp && (
        <OnBoardPopUp
          featureName={item.featureGating.name}
          onClose={() => togglePopUp(false)}
        />
      )}
    </Fragment>
  );
}
